import { useEffect, useState } from 'react';

const useFocus = (ref, defaultState = false): boolean => {
  const [isFocused, setIsFocused] = useState(defaultState);

  useEffect(() => {
    const onFocus: (value: React.SetStateAction<boolean>) => void = () => setIsFocused(true);
    const onBlur: (value: React.SetStateAction<boolean>) => void = () => setIsFocused(false);

    ref.current?.addEventListener('focus', onFocus);
    ref.current?.addEventListener('blur', onBlur);

    return () => {
      ref.current?.removeEventListener('focus', onFocus);
      // eslint-disable-next-line react-hooks/exhaustive-deps
      ref.current?.removeEventListener('blur', onBlur);
    };
  }, [ref]);

  return isFocused;
};

export default useFocus;
